import h from 'react-hyperscript';
import {Link} from 'react-router-dom';
import './Buttons.scss';

/**
 * Creates a Button
 *
 * @param {object} props - The properties passed from Button's parent
 * @return {function} hyperscript function that creates our element
 *
 */
export const Button = (props) => {
  const attributes = {
    id: null,
    className: `${props.buttonClasses} button`,
    to: props.to,
    onClick: props.onClick,
    onKeyUp: props.onKeyUp,
  };

  if (props.className === 'inactive') {
    attributes.className = (attributes.className
        .concat(`--${props.className} margin-right--sm`));
  } else if (props.className) {
    attributes.className = attributes.className.concat(` ${props.className}`);
  }

  if (props.id) {
    attributes.id = props.id;
  }

  if (props.type) {
    attributes.className =
      attributes.className.concat(` button--${props.type}`);
  }

  if (props.noRedirect) {
    return (
      h('button', {
        className: attributes.className,
        onClick: attributes.onClick,
        onKeyUp: attributes.onKeyUp,
      }, props.children)
    );
  } else if (props.external) {
    return (
      h('a', {
        href: props.to,
        target: '_blank',
        className: attributes.className,
        onClick: attributes.onClick,
        onKeyUp: attributes.onKeyUp,
      }, props.children)
    );
  } else {
    return (
      h(
          Link,
          attributes,
          [
            props.icon ? h('img',
                {
                  className: 'button-icon',
                  srcSet: `${props.icon} 1x`,
                },
                null,
            ) : null,
            props.children,
          ],
      )
    );
  }
};

export default Button;
